"use client"

import { PasswordInput, TextInput, TextInputProps } from "@mantine/core"
import { useFormContext } from "react-hook-form"
import getFormError from "../utils/getFormError"
import { cloneElement, JSX } from "react"

export interface LabeledTextFieldProps {
  name: string
}

export const LabeledTextField = ({
  name,
  ErrorComponent,
  type,
  errors: errorMessages,
  ...props
}: LabeledTextFieldProps &
  TextInputProps & { errors?: { [key: string]: JSX.Element }; ErrorComponent?: JSX.Element }) => {
  const {
    register,
    formState: { isSubmitting, errors },
  } = useFormContext()

  const error = getFormError(name, errors)
  const errorElement = errorMessages?.[error]

  const errorProp = error
    ? errorElement
      ? cloneElement(errorElement, {
          defaultValue: error,
          format: { name, label: props.label },
        })
      : ErrorComponent
      ? cloneElement(ErrorComponent, {
          defaultValue: error,
          format: { name, label: props.label },
        })
      : error
    : undefined

  const sharedProps = {
    error: errorProp,
    disabled: isSubmitting,
    ...props,
    ...register(name),
  }

  if (type === "password") {
    const { vars: _vars, ...passwordProps } = sharedProps
    return <PasswordInput {...passwordProps} />
  }

  return <TextInput type={type} {...sharedProps} />
}

export default LabeledTextField
